/* eslint-disable no-console */
<template>

  <div class="main_unit">
    <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
    <div v-show="!isInitLoading">
      <div class="store_login_unit_manage_menu">{{ getStaffName }}</div>
      <div class="wd976 tbl_ht_login_info tbl_bg_blue">
        <form class="form_checkSetting_Tyori">
          <div class="wd720">
            <p class="checkSetting_text">調理名一覧</p><br>
            <Message v-if="validationMessage" :validationMessage="alertMessage" /><br>
            <Message v-if="validationMessage" :validationMessage="validationMessage" />
          </div>

          <div class="lavel_tyori right_comment">
            <label for="diesplaySet_id" class="mgb_20">ボタン選択</label>
          </div>
          <div class="wd200 mgl_24" id="diesplaySet_id" @change="selectCookingId($event)" >
            <select class="wd200"  v-model="selectButton">
              <option value="null" disabled>ボタンを選択</option>
              <option :value="cookingButton.cookingCheckButtonId" v-for="cookingButton in cookingCheckButton" :key="cookingButton.cookingCheckButtonId">
                {{cookingButton.upperButtonName}} {{cookingButton.lowerButtonName}}</option>
            </select>
          </div>

          <div class="lavel_store right_comment" style="vertical-align: middle">
            <label for="releaseSelect">リリース日</label>
          </div>
          <div class="input_store left_comment selectFile mgl_10" id="releaseSelect">
            <p class="wd250 lavel_tyori">{{toDay}}</p>
          </div>
          <div class="lavel_tyori right_comment">
            <label for="diesplayAdd_id"></label>
          </div>
          <div class="admin_button_top_unit mgl_10" id="diesplayAdd_id">
            <div class="checkSetting_buttan_unit ">
              <div class="checkSetting_kanri_box ">
                <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="addColum">行追加</a></li></ul>
              </div>
            </div>
          </div>

          <div class="lavel_tyori right_comment">
            <label for="diesplaySetList_id"></label>
          </div>
          <div  class="tbl_bg_blue mgt_15" name="pageSetting" id="diesplaySetList_id" >
            <table class="tyori_checkSetting_tbl_unit wd750 tyori_setting_height tyori_setting_table mgl_24">
              <tbody>
              <tr>
                <th class="wd70 cooking_setting_sticky_top cooking_setting_sticky_left z_3" rowspan="3" style="text-align: center">表示順</th>
                <th class="wd240 cooking_setting_sticky_top cooking_setting_sticky_left_70 z_3" rowspan="3" style="text-align: center">調理名</th>
                <th v-if="rowspan <= 2" class="wd120 cooking_setting_sticky_top" colspan="2" style="text-align: center">加熱後温度</th>
                <th v-if="rowspan > 2" class="wd120 cooking_setting_sticky_top" rowspan="2" colspan="2" style="text-align: center">加熱後温度</th>
                <th v-if="cookingCheckButtonNo == 5 && rowspan <= 2" class="wd120 cooking_setting_sticky_top" colspan="2" style="text-align: center">再加熱後温度</th>
                <th v-if="cookingCheckButtonNo == 5 && rowspan > 2" class="wd120 cooking_setting_sticky_top" rowspan="2" colspan="2" style="text-align: center">再加熱後温度</th>
                <th class="wd240 cooking_setting_sticky_top" rowspan="3" style="text-align: center">グループ名</th>
                <th class="wd350 cooking_setting_sticky_top" :colspan = colGroupAllCount style="text-align: center">入力制御</th>
                <th class="wd100 cooking_setting_sticky_top" rowspan="3" style="text-align: center">移動</th>
                <th class="wd100 cooking_setting_sticky_top" rowspan="3" style="text-align: center">削除</th>
              </tr>
              <tr v-if="rowspan > 2" class="text_white_space">
                <th v-for="groupSetting in colGroupSetting" :key="groupSetting.colGroupName" class="wd70 test_padding cooking_setting_sticky_top_50" :colspan="groupSetting.colGroupCount" style="text-align: center">
                  {{groupSetting.colGroupName}}</th>
              </tr>
              <tr>
                <th class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">下限</th>
                <th class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">上限</th>
                <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">下限</th>
                <th v-if="cookingCheckButtonNo == 5" class="text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}" style="text-align: center">上限</th>
                <th class="wd70 text_white_space cooking_setting_sticky_top_50" :class="{'cooking_setting_sticky_top_100':rowspan > 2}"  v-for="headerItemName in headerItemNameList" :key="headerItemName.cookingCheckHeaderId" style="text-align: center">
                  {{headerItemName.lowerButtonName}}</th>
              </tr>
              </tbody>
              <tbody>
              <tr v-for="(cookingNameListData,index) in cookingCheckButtonData.cookingNameList" :key="index">
                <td class="cooking_setting_sticky_left" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}">{{cookingNameListData.cookingNameNo}}</td>
                <td class="cooking_setting_sticky_left_70" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}"><input type="text"  :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" class="textbox_td_tyori text-left" maxlength="20" v-model="cookingNameListData.cookingName" :disabled="cookingNameListData.cookingId !== ''"></td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}"><input type="text" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" class="wd60" :disabled="cookingNameListData.cookingId !== ''" v-model="cookingNameListData.heatedLowerTemperature" maxlength="5"></td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}"><input type="text" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" class="wd60" :disabled="cookingNameListData.cookingId !== ''" v-model="cookingNameListData.heatedUpperTemperature" maxlength="5"></td>
                <td v-if="cookingCheckButtonNo == 5" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}"><input type="text" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" class="wd60" :disabled="cookingNameListData.cookingId !== ''" v-model="cookingNameListData.reHeatedLowerTemperature" maxlength="5"></td>
                <td v-if="cookingCheckButtonNo == 5" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}"><input type="text" :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" class="wd60" :disabled="cookingNameListData.cookingId !== ''" v-model="cookingNameListData.reHeatedUpperTemperature" maxlength="5"></td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}">
                  <input :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" class="wd240" list="groupNameList" v-model="cookingNameListData.groupName" @blur="changeGroupName" :disabled="cookingNameListData.cookingId !== ''">
                  <datalist class="wd240" id="groupNameList">
                    <option v-for="groupName in groupNameList" :key="groupName" :value="groupName">
                      {{groupName}}
                    </option>
                  </datalist>
                </td>
                <td   :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" v-for="(inputListData,indexCount) in cookingNameListData.inputList" :key="inputListData.cookingCheckHeaderId">
                  <p v-if="cookingNameListData.cookingId !== '' && inputListData.inputFlg == 0" class="icn_white_td"><i class="far fa-circle"></i></p>
                  <p v-if="cookingNameListData.cookingId !== '' && inputListData.inputFlg == 1" class="icn_blue_td"><i class="far fa-circle"></i></p>
                  <p v-if="cookingNameListData.cookingId !== '' && inputListData.inputFlg == 2" class="icn_yellow_td"><i class="fas fa-play" style="transform: rotate(-90deg)"></i></p>
                  <a v-if="cookingNameListData.cookingId === '' && inputListData.inputFlg == 0" href="#" role="button" @click.prevent.stop="clickChech(index,indexCount,inputListData.cookingCheckHeaderId)">
                    <p class="icn_white_td"><i class="far fa-circle"></i></p></a>
                  <a v-if="cookingNameListData.cookingId === '' && inputListData.inputFlg == 1" href="#" role="button" @click.prevent.stop="clickChech(index,indexCount,inputListData.cookingCheckHeaderId)">
                    <p class="icn_blue_td"><i class="far fa-circle"></i></p></a>
                  <a v-if="cookingNameListData.cookingId === '' && inputListData.inputFlg == 2" href="#" role="button" @click.prevent.stop="clickChech(index,indexCount,inputListData.cookingCheckHeaderId)">
                    <p class="icn_yellow_td"><i class="fas fa-play" style="transform: rotate(-90deg)"></i></p></a>

                </td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" v-if="index == cookingListCount" class="wd100" style="text-align: center" >
                  <input v-if="cookingNameListData.cookingId === ''" type="button" value="▼" @click="lowArrangement(index)">
                </td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" v-else-if="index == cookingCheckButtonData.cookingNameList.length-1" class="wd100" style="text-align: center" >
                  <input v-if="cookingNameListData.cookingId === ''" type="button" value="▲" @click="upArrangement(index)"><br>
                </td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}" v-else class="wd100" style="text-align: center">
                  <input v-if="cookingNameListData.cookingId === ''" type="button" value="▲" @click="upArrangement(index)"><br>
                  <input v-if="cookingNameListData.cookingId === ''" type="button" value="▼" @click="lowArrangement(index)">
                </td>
                <td :class="{'tyori_setting_tbl_not_editable':cookingNameListData.cookingId !== ''}">
                  <div v-if="cookingNameListData.cookingId === ''" class="checkSetting_kanri_box ">
                    <ul class="ul_tbl_buttan"><li><a href="#" @click.prevent.stop="delecSelect(index)">削除</a></li></ul>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </form><br>
      </div>
      <div>
        <div class="btn_submit" style="text-align: center">
          <ul class="set_ul_tbl_buttan" style="display: inline-block">
            <li>
              <router-link class="checkSetting_buttan_unit" :to="{ name: 'cookingCheckInput', params: {menuId:menuId,subMenuId:subMenuId}} ">キャンセル</router-link>
            </li>
          </ul>
          <ul class="set_ul_tbl_buttan" style="display: inline-block">
            <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="releaseDayUpAdd">更新</a></li>
          </ul>
          <ul class="set_ul_tbl_buttan" style="display: inline-block">
            <li><a class="checkSetting_buttan_unit btn_preview_color" href="#" @click.prevent.stop="openPreview()">プレビュー</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="overlay_loder" v-show="isLoading">
      <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
    </div>
    <div class="overlay" v-show="showContent2">
      <div>
        <div class="modal_box wd570">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p v-if="showContentKbn == 2 || showContentKbn == 4" class="modal_header_tit">調理名登録 更新確認</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p v-if="showContentKbn == 4 && applyStartDate !== null">リリース日{{applyStartDate}}の設定を更新します。<br>よろしいですか？
              <br><br>現時点での表示設定に戻ります。<br>登録/更新した情報を確認する場合には、上部「リリース日」にて日付を選択してください。</p>
          </div>
          <div class="btn_submit_box">
            <div class="btn_submit2">
              <a href="#" @click.prevent.stop="closeModelDelete">キャンセル</a>
            </div>
            <div class="btn_submit">
              <a v-if="showContentKbn == 2 || showContentKbn == 4" href="#" @click.prevent.stop="sendSenser">OK</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showContent3">
      <div>
        <div class="modal_box wd570">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p v-if="showContentKbn == 2 || showContentKbn == 4" class="modal_header_tit">調理名登録 更新確認</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p v-if="showContentKbn == 2 || showContentKbn == 4">更新しました。</p>
          </div>

          <div class="btn_submit_box">
            <div class="btn_submit">
              <a href="#" @click.prevent.stop="closeModelComp">OK</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import PulseLoader from '@/app/components/PulseLoader.vue'
import Message from '@/app/components/Message.vue'
export default {
  name: 'TyoriSetting',
  components: {
    PulseLoader,
    Message
  },
  props:{
    menuId: {
      type: Number,
      require: true,
    },
    subMenuId: {
      type: Number,
      require: true
    },
  },
  data: function () {
    return {
      vDatePickerMinDay:null,
      selectButton:null,
      showContentKbn:null,
      showContent3:false,
      showContent2:false,
      applyStartDate:null,
      releaseHistories:[],
      date:null,
      errr:null,
      isLoading:false,
      isInitLoading:true,
      validationMessage:'',
      alertMessage:'入力エラーがあります。',
      showContent:false,
      rowspan:0,
      colGroupSetting:[{colGroupCount:null,colGroupName:''}],
      colGroupAllCount:0,
      selectButtonId:null,
      cookingCheckButtonId:null,
      tyoriDataList:[
        {no:null,cookingName:'',inputList:[{cookingCheckHeaderId:null,inputFlg:null}]}
      ],
      headerItemNameList:[{lowerButtonName:'',cookingCheckHeaderId:null}],
      // 重要管理項目チェックボタン一覧取得
      cookingCheckButton: null,
      cookingCheckButtonData: {
        cookingCheckButtonId: "",
        cookingNameList: null,
        headerItemList: null
      },
      cookingListCount: 0,
      selectGroupName:"",
      groupNameList:[],
      cookingCheckButtonNo:0,
    }
  },
  computed:{
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
    toDay: function () {
      return this.selectDateFormat(new Date());
    },
    getStaffName:function () {
      return  this.$store.getters['staff/name'];
    },
  },
  created: function(){
    this.calc();
  },
  methods:{
    async calc(){

      this.isInitLoading = true;

      //重要管理項目メニュー設定取得API
      var brandId = this.$store.getters['brand/id'];
      var datetime = this.dateFormat();
      var url = this.$apiEndpoint + 'user/brand/' + brandId + '/cooking_check?datetime=' + datetime;
      var storeId = this.$store.getters['store/id']

      await this.$axios
          .get(url,{storeId:storeId})
          .then(response => (this.cookingCheckButton = response.data.cookingCheckButton))
          .catch((err)=> {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(()=> this.isInitLoading = false);

    },
    openPreview() {
      this.isLoading = true;

      //エラー内容初期化
      this.clearError();

      // 種別の選択確認
      if(this.cookingCheckButtonId === null){
        this.validationMessage = 'ボタン名を選択してください。'
        this.isLoading = false;
        this.scrollTop();
        return null;
      }

      let cookingNameListArray = this.cookingCheckButtonData.cookingNameList;
      let cookingList = this.getRequestArray(cookingNameListArray);

      // バリデーションチェック
      if(!this.validationCheckForPreview(cookingNameListArray)){
        this.isLoading = false;
        this.scrollTop();
        return null;
      }

      cookingList = cookingList.map(x => {
        return {
          cookingName: x.cooking_name,
          cookingNameNo: x.no,
          inputList: x.inputList.map(y => {
            return {
              cookingCheckHeaderId: y.cooking_check_header_id,
              inputFlg: y.input_flg,
            }
          }),
          groupName: x.groupName,
          heatedUpperTemperature:x.heatedUpperTemperature,
          heatedLowerTemperature:x.heatedLowerTemperature,
          reHeatedUpperTemperature:x.reHeatedUpperTemperature,
          reHeatedLowerTemperature:x.reHeatedLowerTemperature,
        }
      });

      let previewInfo = {
        upperButtonName: '',
        lowerButtonName: '',
        cookingList: cookingList
      };

      this.cookingCheckButton.some(obj => {
        if(obj.cookingCheckButtonId == this.cookingCheckButtonId){
          previewInfo.upperButtonName = obj.upperButtonName;
          previewInfo.lowerButtonName = obj.lowerButtonName;
          return true;
        }
      });

      this.$store.dispatch('preview/doClear')
      this.$store.dispatch('preview/setPreviewInfo', previewInfo);

      //別タブ表示
      let routeData = this.$router.resolve({name: 'cookingCheckInputStorePreview', params: { subMenuId: Number(this.cookingCheckButtonId) }});
      window.open(routeData.href, '_blank');
      this.isLoading = false;
    },
    validationCheckForPreview(cookingNameListArray){

      //最小件数チェック
      if (cookingNameListArray.length == 0) {
        this.validationMessage = '調理名は1件以上登録を実施してください。'
        return false;
      }

      //最大件数チェック
      if (cookingNameListArray.length>200) {
        this.validationMessage = '調理名は200件まで登録可能です'
        return false;
      }

      //必須チェック
      for(var L = 0 ; L < cookingNameListArray.length ; L++) {
        if(!cookingNameListArray[L].cookingName){
          this.validationMessage = "調理名を入力してください。";
          return false;
        }
      }

      //重複チェック
      for(var h = 0 ; h < cookingNameListArray.length ; h++) {

        if ((h + 1) !== cookingNameListArray.length) {
          var inpuotApiDataObj = cookingNameListArray[h];
          for (var i = h+1; i < cookingNameListArray.length; i++) {
            if (inpuotApiDataObj.cookingName == cookingNameListArray[i].cookingName) {
              this.validationMessage = '調理名は既に登録されています'
              return false;
            }
          }
        }
      }
      return true;
    },
    validationCheck(cookingNameListArray) {

      // 種別の選択確認
      if(this.cookingCheckButtonId === null){
        this.validationMessage = 'ボタン名を選択してください。'
        return false;
      }

      //最小件数チェック
      if (cookingNameListArray.length == 0) {
        this.validationMessage = '調理名は1件以上登録を実施してください。'
        return false;
      }

      //最大件数チェック
      if (cookingNameListArray.length>200) {
        this.validationMessage = '調理名は200件まで登録可能です'
        return false;
      }

      //必須チェック
      for(var L = 0 ; L < cookingNameListArray.length ; L++) {
        if(!cookingNameListArray[L].cookingName){
          this.validationMessage = "調理名を入力してください。";
          return false;
        }
      }

      //桁数チェック
      for(var p = 0 ; p < cookingNameListArray.length ; p++) {
        if(String(cookingNameListArray[p].cookingName).length > 20){
          this.validationMessage = "調理名は20桁以内で入力してください。";
          return false;
        }
      }
      for(var r = 0 ; r < cookingNameListArray.length ; r++) {
        if(String(cookingNameListArray[r].groupName).length > 20){
          this.validationMessage = "グループ名は20桁以内で入力してください。";
          return false;
        }
      }
      //重複チェック
      for(var h = 0 ; h < cookingNameListArray.length ; h++) {

        if ((h + 1) !== cookingNameListArray.length) {
          var inpuotApiDataObj = cookingNameListArray[h];
          for (var i = h+1; i < cookingNameListArray.length; i++) {
            if (inpuotApiDataObj.cookingName == cookingNameListArray[i].cookingName) {
              this.validationMessage = '調理名は既に登録されています'
              return false;
            }
          }
        }
      }

      // リリース日の必須チェック

      if(this.applyStartDate == null){
        this.validationMessage="リリース日を入力してください。"
        this.addFormFlg = false;
        return;
      }

      // リリース日が現在、または過去の指定はNG
      let exist = this.releaseHistories.includes(this.applyStartDate);
      if(!exist){
        this.validationMessage="リリース日はリストから選択してください。"
        return false;
      }

      // 指定されたリリース日が半年以上の場合はNG
      var toDate = new Date()
      toDate.setDate(toDate.getDate()+180);
      var newApplyStartDate = new Date(this.applyStartDate);
      if(this.selectDateFormat(newApplyStartDate) > this.selectDateFormat(toDate)){
        this.validationMessage="リリース日は半年以内で入力してください。"
        return false;
      }

      // 温度の形式チェック
      for(var k = 0 ; k < cookingNameListArray.length ; k++) {
        if (!this.checkStrong2(cookingNameListArray[k].heatedUpperTemperature) || !this.checkStrong2(cookingNameListArray[k].heatedLowerTemperature)) {
          this.validationMessage = '加熱後温度の上・下限は 数字、記号「.」「-」 のみ使用できます。';
          return false;
        }
        if (this.cookingCheckButtonNo == 5 && !this.checkStrong2(cookingNameListArray[k].reHeatedUpperTemperature) || !this.checkStrong2(cookingNameListArray[k].reHeatedLowerTemperature)) {
          this.validationMessage = '再加熱後温度の上・下限は 数字、記号「.」「-」 のみ使用できます。';
          return false;
        }
      }

      return true;
    },
    addColum(){

      // 種別の選択確認
      this.validationMessage = "";
      if(this.cookingCheckButtonId === null){
        this.validationMessage = 'ボタン名を選択してください。'
        this.scrollTop();
        return null;
      }

      if(this.cookingCheckButtonData.cookingNameList.length >= 200 ){
        this.validationMessage = '調理名は200件まで登録可能です'
        this.scrollTop();
        return null;
      }

      var newInputList = new Array();
      for(var i =0 ; i < this.headerItemNameList.length ; i++) {
        var newItemInputObj = new Object();
        newItemInputObj['cookingCheckHeaderId'] = this.headerItemNameList[i].cookingCheckHeaderId;
        newItemInputObj['inputFlg'] = 1;
        newInputList.push(newItemInputObj);
      }

      var cookingNameListOjb = new Object();
      cookingNameListOjb['inputList'] = newInputList;
      cookingNameListOjb['cookingId'] = '';
      cookingNameListOjb['cookingName'] = '';
      cookingNameListOjb['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList.length + 1;
      cookingNameListOjb['groupName'] = null;
      cookingNameListOjb['heatedUpperTemperature'] = null;
      cookingNameListOjb['heatedLowerTemperature'] = null;
      cookingNameListOjb['reHeatedUpperTemperature'] = null;
      cookingNameListOjb['reHeatedLowerTemperature'] = null;
      this.cookingCheckButtonData.cookingNameList.push(cookingNameListOjb);

    },
    delecSelect(indexCount){
      //当日反映の場合は既存の変更はできない
      if(this.cookingCheckButtonData.cookingNameList[indexCount].cookingId === '') {
        var tyoriDataList = [];
        tyoriDataList = this.cookingCheckButtonData['cookingNameList'];
        tyoriDataList.splice(indexCount,1);

        //indexを振りなおす
        for (var k = 0; k < tyoriDataList.length; k++) {
          var deleteApiDataObj = tyoriDataList[k];
          deleteApiDataObj['cookingNameNo'] = k+1;
          tyoriDataList.splice(k,1,deleteApiDataObj);
        }
        this.cookingCheckButtonData.cookingNameList = tyoriDataList;
      }
    },
    async sendSenser(){

      this.showContent2 = false;
      this.isLoading = true;

      //エラー内容初期化
      this.clearError();

      var cookingNameListArray = this.cookingCheckButtonData.cookingNameList.filter(e => e.cookingId === '');

      // バリデーションチェック
      if(!this.validationCheck(cookingNameListArray)){
        this.isLoading = false;
        this.scrollTop();
        return null;
      }

      //正常時、API呼び出し
      let ListArrayRequestArray = this.getRequestArray(cookingNameListArray);

      // API処理判定
      var apiResponseFlg = true;

      var brandId = this.$store.getters['brand/id'];
      var storeId = '';
      var cookingCheckButtonId = this.selectButtonId;
      var url = this.$apiEndpoint + 'user/brand/' + brandId + '/cooking_check/' + cookingCheckButtonId + '/cooing_name';

      // 連携する日付を設定(日付は常にリリース日を入力の内容を送信する)
      //企業管理者
      const toDay = new Date();
      let latestDate = this.releaseHistories
          .map(date => new Date(date))
          .filter(date => date <= toDay)
          .sort((a, b) => b - a)[0] || null;
      let newApplyStartDate = new Date(latestDate);
      let postApplyStartDate = this.selectDateFormat(newApplyStartDate);
      storeId = this.$store.getters['store/id']


      await this.$axios
          .post(url,{cookingNameList:ListArrayRequestArray,apply_start_date: postApplyStartDate,storeId:storeId})
          .then()
          .catch((err)=> {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            apiResponseFlg = false;
            if (err.customError) {
              error = Object.assign(error, err.customError);

              if(error.code == 400){
                this.validationMessage =  error.message;
                this.scrollTop();
              }
            }
            if(error.code !== 400){
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
          }).finally(()=> this.isLoading = false);

      // API処理判定
      if(apiResponseFlg){
        this.showContent3 = true;
      }
    },
    getRequestArray(cookingNameListArray) {
      var ListArrayRequestArray = new Array();
      // 送信用データ作成
      for(var listArrayCount =0 ; listArrayCount < cookingNameListArray.length ; listArrayCount++){
        var requestObj = new Object();
        var ListArrayDataArray = new Array();
        for(var listArrayDataCount = 0 ; listArrayDataCount < cookingNameListArray[listArrayCount].inputList.length ; listArrayDataCount++){
          var ListArrayDataObj = new Object();
          ListArrayDataObj['cooking_check_header_id'] = cookingNameListArray[listArrayCount].inputList[listArrayDataCount].cookingCheckHeaderId;
          ListArrayDataObj['input_flg'] = cookingNameListArray[listArrayCount].inputList[listArrayDataCount].inputFlg;
          ListArrayDataArray.push(ListArrayDataObj);
        }
        requestObj['no'] = cookingNameListArray[listArrayCount].cookingNameNo;
        requestObj['cooking_name'] = cookingNameListArray[listArrayCount].cookingName;
        requestObj['inputList'] = ListArrayDataArray;
        requestObj['groupName'] = cookingNameListArray[listArrayCount].groupName;
        requestObj['heatedUpperTemperature'] = cookingNameListArray[listArrayCount].heatedUpperTemperature;
        requestObj['heatedLowerTemperature'] = cookingNameListArray[listArrayCount].heatedLowerTemperature;
        requestObj['reHeatedUpperTemperature'] = cookingNameListArray[listArrayCount].reHeatedUpperTemperature;
        requestObj['reHeatedLowerTemperature'] = cookingNameListArray[listArrayCount].reHeatedLowerTemperature;
        ListArrayRequestArray.push(requestObj)
      }
      return ListArrayRequestArray;
    },
    async selectCookingId(event){

      this.isLoading = true;
      var brandId = this.$store.getters['brand/id'];
      var storeId = this.$store.getters['store/id'];
      var apiResponseFlg = true;
      if(event !== null){
        this.selectButtonId = event.target.value;
        this.cookingCheckButtonId = event.target.value;
        // ボタン選択が変更された場合、リリース日、入力を初期化する。
        this.date = null;
        this.applyStartDate = null;
        // datepikerの日付を成形(翌日日付け)
        this.vDatePickerMinDay = this.checkDateBusinessDay();
      }

      // 種別の選択確認
      this.validationMessage = "";
      if(this.cookingCheckButtonId === null){
        this.validationMessage = 'ボタン名を選択してください。'
        this.isLoading = false;
        this.scrollTop();
        return null;
      }

      var applyStartDate = "";
      // 取得する日付を指定
      if(this.applyStartDate !== null){
        applyStartDate = this.applyStartDate;
      }

      this.cookingCheckButtonNo = this.cookingCheckButton.find(item => item.cookingCheckButtonId == parseInt(this.cookingCheckButtonId)).cookingCheckButtonNo;
      // 調理名一覧取得API
      var url = this.$apiEndpoint + 'user/brand/' + brandId + '/cooking_check/' + this.cookingCheckButtonId + '/cooing_name';

      await this.$axios
          .get(url,{ params: {apply_start_date:applyStartDate, storeId: storeId}})
          .then(response => (this.cookingCheckButtonData = response.data.cookingCheckButton,
              this.releaseHistories = response.data.cookingCheckButton.releaseHistories,
              this.applyStartDate = response.data.cookingCheckButton.applyStartDate,
              this.cookingListCount = this.cookingCheckButtonData.cookingNameList.length,
              this.groupNameList = [...new Set(this.cookingCheckButtonData.cookingNameList.map(item => item.groupName).filter(group => group))]))
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params:{brandPath: this.brandPath}}
              }}
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(()=> this.isLoading = false);

      // API処理判定
      if(!apiResponseFlg){
        return null;
      }

      var headerAllCount = 0;
      var groupCount = 0
      var headerItemListkeys = Object.keys(this.cookingCheckButtonData.headerItemList);
      var headerItemInputList = new Array();
      this.headerItemNameList = [];
      for(var i =0 ; i < headerItemListkeys.length ; i++){

        var headerItemInputObj = new Object();

        // キー情報
        var headerKey = headerItemListkeys[i];
        var headerItemListData = this.cookingCheckButtonData.headerItemList[headerKey];
        // キー別のリストカウント
        var headerItemListDataCount = headerItemListData.length;

        // ヘッダー名を格納
        for(var k =0 ; k < headerItemListData.length ; k++){
          this.headerItemNameList.push(headerItemListData[k])
        }

        // Dataへ格納
        headerItemInputObj['colGroupName'] = headerKey;
        if(headerKey === 'inputType_4') {
          headerItemInputObj['colGroupName'] = '';
        }
        headerItemInputObj['colGroupCount'] = headerItemListDataCount;
        headerItemInputList.push(headerItemInputObj);
        headerAllCount = headerAllCount + headerItemListDataCount;
        groupCount = groupCount + 1;
      }
      this.colGroupSetting = headerItemInputList;
      this.colGroupAllCount = headerAllCount;
      this.rowspan = groupCount;


    },
    clearError:function(){
      //メッセージ初期化
      this.validationMessage = "";
    },
    closeModel() {
      this.showContent = false;
    },
    dateFormat(){
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
      let day = ("0" + nowDate.getDate()).slice(-2);
      let hours = ("0" + nowDate.getHours()).slice(-2);
      let minutes = ("0" + nowDate.getMinutes()).slice(-2);
      let seconds = ("0" + nowDate.getSeconds()).slice(-2);

      let format_str = 'YYYYMMDDhhmmss'
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);
      format_str = format_str.replace(/hh/g,hours);
      format_str = format_str.replace(/mm/g,minutes);
      format_str = format_str.replace(/ss/g,seconds);
      return format_str;
    },
    //〇ボタン押下時のlist書き換え用メソッド
    clickChech:function (index,indexCount,cookingCheckHeaderId) {
      if(this.cookingCheckButtonData.cookingNameList[index].cookingId === '') {
        //ボタン押下時のクリック制御
        var buttonCheckList = this.cookingCheckButtonData.cookingNameList[index].inputList[indexCount];
        if (buttonCheckList['inputFlg'] == 0) {
          buttonCheckList['inputFlg'] = 1;
          buttonCheckList['cookingCheckHeaderId'] = cookingCheckHeaderId;
        }else if(buttonCheckList['inputFlg'] == 1){
          buttonCheckList['inputFlg'] = 2;
          buttonCheckList['cookingCheckHeaderId'] = cookingCheckHeaderId;
        } else {
          buttonCheckList['inputFlg'] = 0;
          buttonCheckList['cookingCheckHeaderId'] = cookingCheckHeaderId;
        }
        this.cookingCheckButtonData.cookingNameList[index].inputList.splice(indexCount, 1, buttonCheckList);
      }
    },
    upArrangement:function (arrangementRuleNo) {
      if((this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingId === '' && this.cookingCheckButtonData.cookingNameList[arrangementRuleNo - 1].cookingId === '')) {
        var upparData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo];
        upparData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingNameNo-1;

        var lowerData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo-1];
        lowerData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingNameNo+1;

        //配列に反映
        this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo-1,1,upparData);
        this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo,1,lowerData);
      }
    },
    lowArrangement:function (arrangementRuleNo) {
      //当日反映の場合は既存の変更はできない
      if(this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingId === '') {
        var upparData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo + 1];
        upparData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo + 1].cookingNameNo-1;

        var lowerData = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo];
        lowerData['cookingNameNo'] = this.cookingCheckButtonData.cookingNameList[arrangementRuleNo].cookingNameNo+1;


        //配列に反映
        this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo,1,upparData);
        this.cookingCheckButtonData.cookingNameList.splice(arrangementRuleNo+1,1,lowerData);
      }
    },
    scrollTop() {
      window.scrollTo(0,0);
    },
    releaseDayUpAdd(){

      //エラー内容初期化
      this.clearError();

      // バリデーションチェックを実施
      let cookingNameListArray = this.cookingCheckButtonData.cookingNameList;

      // バリデーションチェック
      if(!this.validationCheck(cookingNameListArray)){
        this.scrollTop();
        return null;
      }


      this.showContentKbn = 4;
      this.showContent2 = true;

    },
    closeModelDelete(){
      this.showContent2 = false;
    },
    closeModelComp(){
      this.showContent3 = false;
      // 削除の場合、画面を初期化する。
      if(this.showContentKbn == 3){
        // 削除の場合、リリース日の指定は初期化する
        this.applyStartDate = null;
      }
      // 初期化処理
      this.selectCookingId(null);
      // パラメータ初期化
      this.showContentKbn = null;
      this.date = null;
      this.scrollTop();
    },
    selectDateFormat(date){
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
    init(){
      // 画面の初期化
      this.selectCookingId(null);
    },
    jsonToFormData(data) {
      const formData = new FormData();

      this.buildFormData(formData, data);

      return formData;
    },
    buildFormData(formData, data, parentKey) {
      if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
          this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
      } else {
        const value = data == null ? '' : data;

        formData.append(parentKey, value);
      }
    },
    checkDateBusinessDay(){
      let minAllowedDay = new Date();
      let hours = ("0" + minAllowedDay.getHours()).slice(-2);

      // AM00-AM03時の判定
      if(hours >= '03' && hours <= '23'){
        minAllowedDay.setDate(minAllowedDay.getDate() +1);
      }
      return new Date(minAllowedDay.getFullYear(),minAllowedDay.getMonth(),minAllowedDay.getDate());
    },
    chartDateBusinessDay(date){

      let year = date.getFullYear();
      let month = ("0" + (date.getMonth()+1)).slice(-2);
      let day = ("0" + date.getDate()).slice(-2);
      let hours = ("0" + date.getHours()).slice(-2);

      // AM00-AM03時の判定
      if(hours >= '00' && hours < '03'){

        // 年始の考慮
        if(month == '01' && day == '01'){
          var yearEndDate = new Date(date.getFullYear()-1,12,0);
          year = date.getFullYear()-1;
          month = 12;
          day = ("0" + yearEndDate.getDate()).slice(-2);

        }
        // 月末の考慮
        else if(day == '01'){
          var monthEndDate = new Date(date.getFullYear(),date.getMonth(),0);
          month = ("0" + (date.getMonth())).slice(-2);
          day = ("0" + monthEndDate.getDate()).slice(-2);
        }
        // 前日日付の営業日
        else{
          var dayBeforeDate = new Date(date.getFullYear(),date.getMonth()+1,date.getDate()-1);
          day =  ("0" + dayBeforeDate.getDate()).slice(-2);
        }
      }

      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g,year);
      format_str = format_str.replace(/MM/g,month);
      format_str = format_str.replace(/DD/g,day);

      return format_str;
    },
    changeGroupName() {
      this.groupNameList = [...new Set(this.cookingCheckButtonData.cookingNameList.map(item => item.groupName).filter(group => group))];
    },
    //数字、記号「.」「-」 のチェック
    checkStrong2:function(inputdata){
      if(!inputdata){
        return true;
      }

      const re = new RegExp(/^[-]?([1-9]\d*|0)(\.\d+)?$/);
      return re.test(inputdata);
    },
  }
}
</script>